export default __webpack_public_path__ + "static/media/location.aa40c7f3.svg";